import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    HostBinding,
    Input,
    ViewChild,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { HeaderComponent } from "../header/header.component";

@Component({
    selector: "rask-container-block",
    styleUrls: ["./block.component.scss"],
    templateUrl: "./block.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HeaderComponent]
})
export class BlockComponent implements AfterViewInit {
    @ViewChild("footer") footer: ElementRef;
    @ViewChild(HeaderComponent, { read: ElementRef }) header: ElementRef;
    @Input() noBorder: boolean;
    showFooter = true;
    showHeader = true;

    private readonly cdRef = inject(ChangeDetectorRef);

    @HostBinding("attr.noborder") get getNoBorderState() { return (this.noBorder ? "" : null);}

    isEmpty(element: ElementRef) {
        return !element || !element.nativeElement || element.nativeElement.childNodes.length === 0;
    }

    ngAfterViewInit(): void {
        this.showFooter = !this.isEmpty(this.footer);
        this.showHeader = !this.isEmpty(this.header);
        this.cdRef.detectChanges();
    }
}
